module.exports = __webpack_public_path__ + "media/images/all-care-benefits-form-1cdba3daa4f2603e274875c7d031979b.png";